<template>
    <div class="row">
        <div class="col-md-12">
            <div>
                <div class="pull-left">
                    <div class="p-2">
                        <span>{{ lang('app.rows_per_page_text') }} : </span>
                        <select class="rowsPerPageClass" name="rowsPerPage" id="rowsPerPage" v-model="rowsPerPage">
                            <option value="15">15</option>
                            <option value="30">30</option>
                            <option value="45">45</option>
                            <option value="60">60</option>
                            <option value="90">90</option>
                        </select>
                    </div>
                </div>
                <div class="pull-right mb-3">
                    <router-link class="btn btn-brand" :to="{ name: 'admin.organisations.create' }">{{ uLang('app.add_type', { type: lang('app.organisation') }) }}</router-link>
                </div>
            </div>
            <buy-invoices-table :rows-per-page="rowsPerPage" />
        </div>
    </div>
</template>

<script>
    import { BuyInvoicesTable } from '~/components/tables'

    export default {
        name: 'BuyInvoicesTab',

        components: {
            BuyInvoicesTable,
        },

        data() {
            return {
                rowsPerPage: "15",
            }
        },
    }
</script>

<style lang="css" scoped>
.rowsPerPageClass {
    display: inline-block;
    width: 100px;
    padding: 6px;
}
</style>
